import { Model, defaultModel, ModelsData } from '../services/types';
import { getDefaultSubscriptionLimits, getDefaultSubscriptionPrice } from '../services/defaultData';
import { detectRegion } from '../utils/region';

const BASE_URL = 'https://api.tabbyio.com'; // Replace with your actual base URL

export const apiCall = {
  async post(endpoint: string, data: any) {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error(`Error in API call to ${endpoint}:`, error);
      throw error;
    }
  },
  async get(endpoint: string, params?: Record<string, any>) {
    try {
      const token = localStorage.getItem('access_token');
      const url = new URL(`${BASE_URL}${endpoint}`);
      if (params) {
        Object.entries(params).forEach(([key, value]) =>
          url.searchParams.append(key, value)
        );
      }
      const response = await fetch(url.toString(), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    } catch (error) {
      console.error(`Error in API call to ${endpoint}:`, error);
      throw error;
    }
  },
  // Add other methods like get, put, delete as needed
};

export const fetchModels = async (isOpen: boolean, selectedModelId: string): Promise<ModelsData> => {
    if (!isOpen) return {
      models: [defaultModel],
      user_subscription: '',
      subscription_limits: getDefaultSubscriptionLimits(),
      subscription_price: getDefaultSubscriptionPrice(),
    };

    try {
      const token = localStorage.getItem('access_token');
      if (!token) return {
        models: [defaultModel],
        user_subscription: '',
        subscription_limits: getDefaultSubscriptionLimits(),
        subscription_price: getDefaultSubscriptionPrice(),
      };

      const response = await fetch(`https://api.tabbyio.com/models?region=${detectRegion()}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data; // 返回完整的 API 响应数据
      }
    } catch (error) {
      console.error('Error fetching models:', error);
    }

    return {
      models: [defaultModel],
      user_subscription: '',
      subscription_limits: getDefaultSubscriptionLimits(),
      subscription_price: getDefaultSubscriptionPrice(),
    };
  };
